var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-56"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.33,
    y: 395.36,
    width: 12.89,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 396.42,
    width: 27.14,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.67,
    y: 389.21,
    width: 56.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 400.78,
    width: 26.53,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.89,
    y: 400.78,
    width: 23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 395.24,
    width: 60.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.21,
    y: 75.81,
    width: 137.78,
    height: 127.17,
    transform: "translate(288.2 278.79) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.01,
    y: 75.81,
    width: 140.02,
    height: 127.17,
    transform: "translate(282.03 278.79) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.21,
    y: 202.98,
    width: 137.78,
    height: 5.61,
    transform: "translate(288.2 411.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 202.98,
    width: 140.02,
    height: 5.61,
    transform: "translate(268.02 411.57) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.32,
    y: 75.27,
    width: 115.4,
    height: 128.25,
    transform: "translate(280.41 -1.62) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.22 197.1 159.84 81.7 134.28 81.7 150.66 197.1 176.22 197.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.42,191.24a.42.42,0,0,0,.42-.42V85.53a.43.43,0,1,0-.85,0V190.82A.42.42,0,0,0,202.42,191.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.17 197.1 128.79 81.7 118.82 81.7 135.2 197.1 145.17 197.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 139.02,
    width: 115.4,
    height: 0.75,
    transform: "translate(216.66 62.13) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 90.57 207.39 90.57 207.94 83.98 70.16 83.98 69.61 90.57",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 94.28 207.39 94.28 207.94 87.7 70.16 87.7 69.61 94.28",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 98 207.39 98 207.94 91.41 70.16 91.41 69.61 98",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 101.72 207.39 101.72 207.94 95.13 70.16 95.13 69.61 101.72",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 105.43 207.39 105.43 207.94 98.84 70.16 98.84 69.61 105.43",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 109.15 207.39 109.15 207.94 102.56 70.16 102.56 69.61 109.15",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.3,
    y: 216.61,
    width: 29.04,
    height: 161.24,
    transform: "translate(833.64 594.47) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.56,
    y: 377.86,
    width: 143.2,
    height: 4.54,
    transform: "translate(708.32 760.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.99,
    y: 216.61,
    width: 125.31,
    height: 161.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 278.65,
    width: 102.48,
    height: 37.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 324.11,
    width: 102.48,
    height: 37.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.31,
    y: 277.4,
    width: 28.67,
    height: 6.23,
    rx: 2.69,
    transform: "translate(679.29 561.03) rotate(-180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 233.19,
    width: 102.48,
    height: 37.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.31,
    y: 231.94,
    width: 28.67,
    height: 6.23,
    rx: 2.69,
    transform: "translate(679.29 470.12) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.31,
    y: 322.86,
    width: 28.67,
    height: 6.23,
    rx: 2.69,
    transform: "translate(679.29 651.95) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.12,
    y: 210.56,
    width: 129.18,
    height: 6.06,
    transform: "translate(675.42 427.17) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.3,
    y: 210.56,
    width: 33.1,
    height: 6.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.25,
    y: 229.22,
    width: 13.01,
    height: 148.05,
    transform: "translate(263.51 606.5) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.78,
    y: 377.28,
    width: 72.05,
    height: 5.11,
    transform: "translate(197.6 759.66) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.35,
    y: 229.22,
    width: 65.91,
    height: 148.05,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.37,
    y: 306.32,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.37,
    y: 340.92,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.47,
    y: 317.72,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(184.6 639.07) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.47,
    y: 352.32,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(184.6 708.27) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.37,
    y: 237.39,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.37,
    y: 271.72,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.47,
    y: 248.79,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(184.6 501.21) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.47,
    y: 283.12,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(184.6 569.87) rotate(-180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.38,
    y: 229.22,
    width: 21.52,
    height: 148.05,
    transform: "translate(416.27 606.5) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 377.28,
    width: 80,
    height: 5.11,
    transform: "translate(349.8 759.66) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 229.22,
    width: 65.91,
    height: 148.05,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 306.32,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 340.92,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 317.72,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(328.84 639.07) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 352.32,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(328.84 708.27) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 237.39,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 271.72,
    width: 51.85,
    height: 26.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 248.79,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(328.84 501.21) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.6,
    y: 283.12,
    width: 17.65,
    height: 3.63,
    rx: 1.5,
    transform: "translate(328.84 569.87) rotate(-180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.43 155.31 406.41 155.31 403.82 102.43 384.43 102.43 384.43 155.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.82 158.17 423.56 173.88 418.82 173.88 389.76 158.17 418.82 158.17",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.56 158.17 423.56 173.88 394.5 158.17 423.56 158.17",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.86 158.17 309.6 173.88 304.86 173.88 275.8 158.17 304.86 158.17",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.6 158.17 309.6 173.88 280.54 158.17 309.6 158.17",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.7,
    y: 155.39,
    width: 27.28,
    height: 3.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.07,
    y: 155.39,
    width: 135.63,
    height: 3.39,
    transform: "translate(673.77 314.17) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.15 155.31 399.32 155.31 405.16 91.23 357.98 91.23 352.15 155.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.71 155.31 396.88 155.31 402.71 91.23 355.54 91.23 349.71 155.31",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.92 148.22 398.25 98.32 359.5 98.32 354.17 148.22 392.92 148.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.04 155.31 346.17 155.31 344.38 118.9 331.04 118.9 331.04 155.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.81 155.31 341.29 155.31 345.3 111.19 312.82 111.19 308.81 155.31",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.12 155.31 339.61 155.31 343.62 111.19 311.14 111.19 307.12 155.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.88 150.43 340.55 116.07 313.87 116.07 310.2 150.43 336.88 150.43",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-56"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-56",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "321.1 402.69 313.52 400.61 316.34 382.49 323.92 384.58 321.1 402.69",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.05 407.73 369.18 407.73 367.22 389.52 375.09 389.52 377.05 407.73",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.54,406.82h9.58a.69.69,0,0,1,.67.54l1.56,7a1.16,1.16,0,0,1-1.16,1.4c-3.08-.05-5.33-.24-9.22-.24-2.39,0-9.59.25-12.89.25s-3.74-3.26-2.39-3.56c6.06-1.32,10.63-3.15,12.57-4.89A1.9,1.9,0,0,1,368.54,406.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,399.74l8.28,2.28a.69.69,0,0,1,.5.7l-.36,7.15a1.14,1.14,0,0,1-1.46,1.05c-3-.88-7.24-2.24-11-3.27-4.39-1.21-8.25-2-13.39-3.44-3.11-.86-3.11-4.24-1.73-4.17,6.29.34,11.17,1.54,17.16-.21A3.65,3.65,0,0,1,313.81,399.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.34 382.5 314.88 391.83 322.47 393.92 323.92 384.59 316.34 382.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.09 389.53 367.22 389.53 368.24 398.92 376.1 398.92 375.09 389.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,158.56l-.68-7.54L275,154.61s1.94,6.69,5.6,6Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.72 147.47 272.4 149.19 275.02 154.61 282.38 151.02 280.72 147.47",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.49,159.7a73.34,73.34,0,0,0-11.32,5.66c-.77.38-1.54.76-2.32,1.12-1.9.86-3.83,1.65-5.77,2.33a35.86,35.86,0,0,1-11.33,2.31c-.42,0-.85,0-1.25-.05l-.29,0h-.13a2.37,2.37,0,0,1-.31-.06,7.58,7.58,0,0,1-1.91-.64,21.66,21.66,0,0,1-4.65-3.25,66.21,66.21,0,0,1-8.62-9.47l-5.13,2.93A68.35,68.35,0,0,0,285.81,173a31.65,31.65,0,0,0,5.5,5.73,15.54,15.54,0,0,0,4.13,2.4,12.72,12.72,0,0,0,1.32.4l.71.16.55.09c.71.13,1.42.21,2.12.28a46.37,46.37,0,0,0,15.4-1.68c2.08-.54,4.1-1.17,6.09-1.86,2.14-.45,19.74-4.35,22.75-10.66C348.27,159.69,340.85,156.36,331.49,159.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.16,176.83a67.56,67.56,0,0,0,7.28-2.54l.6-6.44S331.34,169.77,328.16,176.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,160.84a1.8,1.8,0,0,1,1.29,2.2,180.39,180.39,0,0,0-4.53,24.13c-.74,6.09-1.19,11.9-1.46,17.18-.66,12.36-.39,21.78-.75,25-6.15-.42-29.32-2-42-2.92-5.71-44.73,5.2-67.77,5.2-67.77a82.06,82.06,0,0,1,10-1.25c.71,0,1.43-.07,2.17-.08a155.11,155.11,0,0,1,17.84,1.24c1.12.13,2.25.3,3.36.48C372.74,159.6,376,160.36,378,160.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.33,169a23.93,23.93,0,0,0,2.76,15.39c.5-3.71,1.12-7.5,1.88-11.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,138.33c-1.53,5.67-3,15.78-.08,20.31-3.15,2.82-6.9,2.11-10.11,1.61-3.91-.61-4.43-1.5-3.19-3.33.77-.84.91-1.7,1.64-3.66a12.52,12.52,0,0,0,.14-6.34Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.8,154.5c.51,2.57-2.67,3.94-1.74,5.06s9.22,3.94,12.87,2.61,3.26-1.66,3-4.88,1.8-5.32-.86-4.46c-1.36.44-8.42-.72-10.45-.72S351.39,152.44,351.8,154.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.71,141.84l-6.87,5.07a17.75,17.75,0,0,1,.33,3.21c2.47-.18,6-2.63,6.46-5.17A8.73,8.73,0,0,0,360.71,141.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.25,119.44c-1.75.81-4.58,4.59-2.25,7.09S352.72,118.31,350.25,119.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.74,130.08c-1.29,7.7-1.66,12.27-6,15.84-6.51,5.36-15.7.8-16.74-7.13-.93-7.13,1.34-18.52,9.25-20.8A10.64,10.64,0,0,1,367.74,130.08Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,135.6c-2.88-1.83-3-3.95-2.13-5.85,2.77-6.42,2-9.67-2.92-9.08s-11.93,1.16-11.06-1.09,7.05-3.2,12.3-2.58,10.88,4.7,9.76,11.12C370.31,134.26,369,136,365.44,135.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5,137.35a7.45,7.45,0,0,1-4.49,3.46c-2.52.66-3.73-1.6-3-4,.66-2.11,2.77-5,5.28-4.63S371.68,135.25,370.5,137.35Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,389.3l12.83,3.53s10.11-50.67,10.74-75.16c.19-7.45,3.41-16.26,5.87-27.32,3.12-13.93,7-29,10.22-40.8,3.38-12.43,5.95-21.22,5.95-21.22l-27.58-1.93s-14.24,65.41-15.95,89.35C312.82,340.64,312.53,389.3,312.53,389.3Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,389.3l12.83,3.53s10.11-50.67,10.74-75.16c.19-7.45,3.41-16.26,5.87-27.32,3.12-13.93,7-29,10.22-40.8,3.38-12.43,5.95-21.22,5.95-21.22l-27.58-1.93s-14.24,65.41-15.95,89.35C312.82,340.64,312.53,389.3,312.53,389.3Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,290.35c3.12-13.93,7-29,10.22-40.8l-2.86-6.17C342.49,251.51,340.65,276.68,342,290.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.44,227.44s2,62.56,5.28,85.36c3.64,25,13.88,84.3,13.88,84.3H379s-.77-56.5-5.28-80.69c-5.14-27.54-1.21-87.08-1.21-87.08Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.44,227.44s2,62.56,5.28,85.36c3.64,25,13.88,84.3,13.88,84.3H379s-.77-56.5-5.28-80.69c-5.14-27.54-1.21-87.08-1.21-87.08Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.88 397.41 379.84 397.41 379.84 392.34 360.88 392.01 362.88 397.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.83 389.15 326.13 393.37 327.49 388.43 310.46 383.46 310.83 389.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,130.51c-.06.63-.45,1.11-.86,1.07s-.7-.59-.63-1.22.45-1.11.87-1.07S356.84,129.88,356.77,130.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.86,130.26c-.06.63-.45,1.11-.87,1.06s-.69-.59-.62-1.22.45-1.1.87-1.06S348.93,129.63,348.86,130.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.21,135a5,5,0,1,1,4.63-5A4.84,4.84,0,0,1,356.21,135Zm0-9.55a4.54,4.54,0,1,0,4.12,4.52A4.33,4.33,0,0,0,356.21,125.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,135a5,5,0,1,1,4.63-5A4.84,4.84,0,0,1,346,135Zm0-9.55A4.54,4.54,0,1,0,350.1,130,4.33,4.33,0,0,0,346,125.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.72,130.67a22.82,22.82,0,0,1-3.11,5.37,3.64,3.64,0,0,0,3,.62Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,128.58a.36.36,0,0,1-.36-.13,3,3,0,0,0-2.42-1.2.37.37,0,1,1-.06-.74,3.7,3.7,0,0,1,3.06,1.47.38.38,0,0,1-.06.53A.46.46,0,0,1,358.65,128.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,140h0a5.75,5.75,0,0,0,4.72-2.35.2.2,0,0,0-.34-.22,5.43,5.43,0,0,1-4.38,2.17.2.2,0,1,0,0,.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5,128.61a.46.46,0,0,1-.23-.06.38.38,0,0,1-.12-.51,3.7,3.7,0,0,1,2.89-1.81.38.38,0,0,1,.38.37.39.39,0,0,1-.37.38h0a2.91,2.91,0,0,0-2.26,1.45A.39.39,0,0,1,344.5,128.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.94,408.2a2.4,2.4,0,0,1-1.52-.4,1.12,1.12,0,0,1-.38-1,.57.57,0,0,1,.31-.52c.88-.45,3.41,1.11,3.7,1.29a.18.18,0,0,1,.08.18.18.18,0,0,1-.14.16A9.31,9.31,0,0,1,365.94,408.2Zm-1.17-1.63a.43.43,0,0,0-.24.05c-.06,0-.11.07-.12.22a.75.75,0,0,0,.25.67,3.79,3.79,0,0,0,2.79.14A7.59,7.59,0,0,0,364.77,406.57Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,407.92l-.09,0c-.81-.44-2.39-2.17-2.22-3a.61.61,0,0,1,.59-.49,1,1,0,0,1,.8.24c.91.74,1.1,3,1.1,3.11a.17.17,0,0,1-.08.17A.19.19,0,0,1,368,407.92Zm-1.59-3.19h-.08c-.24,0-.27.14-.27.19-.1.51.9,1.82,1.71,2.43a4.41,4.41,0,0,0-.93-2.46A.67.67,0,0,0,366.36,404.73Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,400.58h0c-1.29-.09-3.54-.39-4.17-1.36a1,1,0,0,1-.09-1,.58.58,0,0,1,.42-.4c1.06-.24,3.69,2.13,4,2.4a.18.18,0,0,1-.1.32Zm-3.74-2.36H309a.22.22,0,0,0-.16.17.67.67,0,0,0,.05.63c.36.54,1.58,1,3.33,1.14C311.17,399.25,309.67,398.15,309.05,398.22Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,400.58a.18.18,0,0,1-.14,0c-.8-.66-2.17-2.8-1.79-3.62.09-.19.3-.4.81-.32a1.39,1.39,0,0,1,.91.59c.74,1.05.38,3.15.37,3.24a.17.17,0,0,1-.12.14Zm-1.4-3.62c-.15,0-.18.09-.19.12-.23.49.65,2.11,1.43,2.93a4.34,4.34,0,0,0-.36-2.61,1,1,0,0,0-.67-.43A.8.8,0,0,0,311.39,397Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.79,223.12l-8,.8,4.77,7.57s6.48-2.55,5.51-6.13Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.53 227.9 367.45 234.6 372.6 231.49 367.83 223.92 362.53 227.9",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,188.76c-.72-2-1.54-4-2.41-5.89-.65-2.09-6.15-19.25-12.72-21.67-8.47-3.12-11.1,4.58-6.91,13.59a72.8,72.8,0,0,0,6.68,10.75c.45.73.9,1.46,1.32,2.2,1,1.82,2,3.67,2.86,5.54a35.84,35.84,0,0,1,3.35,11.06c0,.43.06.85.06,1.26v.29a.57.57,0,0,0,0,.13,1.89,1.89,0,0,1,0,.31,7.45,7.45,0,0,1-.46,2,21.91,21.91,0,0,1-2.8,4.93,65.69,65.69,0,0,1-8.65,9.46l3.4,4.84a68.24,68.24,0,0,0,11.69-8.47,32,32,0,0,0,5.21-6,15.56,15.56,0,0,0,2-4.34,11.11,11.11,0,0,0,.28-1.35l.09-.72,0-.56c.06-.72.07-1.43.08-2.13A46.43,46.43,0,0,0,394.5,188.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.07,251.57H252.16a8.38,8.38,0,0,0,8.29-8l3.72-105.92a7.7,7.7,0,0,0-7.72-8H90.35a8.37,8.37,0,0,0-8.29,8L78.34,243.56A7.71,7.71,0,0,0,86.07,251.57Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.07,251.57H252.16a8.38,8.38,0,0,0,8.29-8l3.72-105.92a7.7,7.7,0,0,0-7.72-8H90.35a8.37,8.37,0,0,0-8.29,8L78.34,243.56A7.71,7.71,0,0,0,86.07,251.57Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,251.57h166.1a8.39,8.39,0,0,0,8.29-8l3.72-105.92a7.7,7.7,0,0,0-7.73-8H91.93a8.37,8.37,0,0,0-8.28,8L79.93,243.56A7.7,7.7,0,0,0,87.65,251.57Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,244.9a3.31,3.31,0,0,0,3.27-3.16L259,139.46a3,3,0,0,0-3-3.16H93.52a3.32,3.32,0,0,0-3.27,3.16L86.66,241.74a3,3,0,0,0,3,3.16Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.14,217.22a40.67,40.67,0,0,0,8.76-23.14A37.37,37.37,0,0,0,205.42,171l0-.12a2.91,2.91,0,0,0-.26-.33A36.92,36.92,0,0,0,174.77,155a41.22,41.22,0,0,0-31.93,15.54c-.08.09-.16.17-.23.26a.93.93,0,0,1-.05.1,40.66,40.66,0,0,0-8.77,23.15,37.33,37.33,0,0,0,6.49,23.16.36.36,0,0,0,0,.09l.09.11a36.92,36.92,0,0,0,30.51,15.7,41.22,41.22,0,0,0,31.89-15.5,3.88,3.88,0,0,0,.26-.31A1.05,1.05,0,0,0,203.14,217.22Zm-32,11.27c-5.59,0-10.3-6.53-12.69-16.16A68.2,68.2,0,0,1,172,211a66.37,66.37,0,0,1,13.42,1.34C182.08,222,176.73,228.49,171.15,228.49Zm1.09-22.15a73.21,73.21,0,0,0-14.7,1.46,65,65,0,0,1-.78-11.39H188.7a68.88,68.88,0,0,1-1.9,11.39A71.3,71.3,0,0,0,172.24,206.34Zm-33.83-9.93h13.7a69.53,69.53,0,0,0,.84,12.51,47,47,0,0,0-9.81,4A32.68,32.68,0,0,1,138.41,196.41ZM145,175.25a42.18,42.18,0,0,0,9.42,4,72.54,72.54,0,0,0-2.07,12.52h-13.7A35.8,35.8,0,0,1,145,175.25Zm29.55-15.57c5.59,0,10.29,6.53,12.69,16.16a69.14,69.14,0,0,1-13.56,1.33,67.19,67.19,0,0,1-13.42-1.33C163.6,166.21,169,159.68,174.54,159.68Zm-1.09,22.14a73.35,73.35,0,0,0,14.7-1.46,66,66,0,0,1,.78,11.4H157a67.79,67.79,0,0,1,1.9-11.4A71.15,71.15,0,0,0,173.45,181.82Zm33.83,9.94h-13.7a70.51,70.51,0,0,0-.84-12.52,47.41,47.41,0,0,0,9.81-4A32.78,32.78,0,0,1,207.28,191.76Zm-13.93,4.65h13.7a35.88,35.88,0,0,1-6.36,16.5,42.44,42.44,0,0,0-9.42-4A71.62,71.62,0,0,0,193.35,196.41Zm6.55-24.89a42.62,42.62,0,0,1-8.09,3.19,37.09,37.09,0,0,0-5.66-13A32.29,32.29,0,0,1,199.9,171.52Zm-37.18-9.79a42,42,0,0,0-6.94,13,39.24,39.24,0,0,1-7.77-3.19A37,37,0,0,1,162.72,161.73Zm-16.93,54.92a43.47,43.47,0,0,1,8.08-3.2,37.19,37.19,0,0,0,5.66,13A32.3,32.3,0,0,1,145.79,216.65ZM183,226.43a41.63,41.63,0,0,0,6.94-13,39,39,0,0,1,7.77,3.2A36.91,36.91,0,0,1,183,226.43Z",
    style: {
      fill: "#65C18C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.47 136.3 109.03 244.9 128.25 244.9 142.69 136.3 123.47 136.3",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.25 136.3 134.81 244.9 142.69 244.9 157.14 136.3 149.25 136.3",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.63,133.15a1.18,1.18,0,0,0,1.19,1.23,1.28,1.28,0,0,0,1.27-1.23,1.18,1.18,0,0,0-1.19-1.23A1.28,1.28,0,0,0,173.63,133.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.11,362.12H112a10.69,10.69,0,0,1-9.84-8l-21.26-92.9c-1-4.4,1.77-8,6.17-8h166.1a10.7,10.7,0,0,1,9.84,8l21.26,92.9C285.29,358.52,282.51,362.12,278.11,362.12Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.11,362.12H112a10.69,10.69,0,0,1-9.84-8l-21.26-92.9c-1-4.4,1.77-8,6.17-8h166.1a10.7,10.7,0,0,1,9.84,8l21.26,92.9C285.29,358.52,282.51,362.12,278.11,362.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.7,362.12H113.6a10.68,10.68,0,0,1-9.84-8L82.5,261.21c-1-4.4,1.77-8,6.17-8h166.1a10.7,10.7,0,0,1,9.84,8l21.26,92.9C286.88,358.52,284.1,362.12,279.7,362.12Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81,315.75a4.21,4.21,0,0,1-3.88-3.16L89.59,263A2.44,2.44,0,0,1,92,259.88H254.47a4.2,4.2,0,0,1,3.88,3.16l11.35,49.55a2.45,2.45,0,0,1-2.44,3.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,354.73a2.47,2.47,0,0,1-2.27-1.84L162.87,324a1.43,1.43,0,0,1,1.42-1.84h46.42A2.46,2.46,0,0,1,213,324l6.62,28.89a1.43,1.43,0,0,1-1.42,1.84Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.23,289.9l5-131.77a6.14,6.14,0,0,0-6.1-6.4l-84-.71a6.61,6.61,0,0,0-6.6,6.3l-5,131.76a6.14,6.14,0,0,0,6.1,6.41l84,.71A6.62,6.62,0,0,0,284.23,289.9Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.23,289.9l5-131.77a6.14,6.14,0,0,0-6.1-6.4l-84-.71a6.61,6.61,0,0,0-6.6,6.3l-5,131.76a6.14,6.14,0,0,0,6.1,6.41l84,.71A6.62,6.62,0,0,0,284.23,289.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,289.9l5.05-131.77a6.15,6.15,0,0,0-6.11-6.4L201,151a6.61,6.61,0,0,0-6.6,6.3l-5,131.76a6.14,6.14,0,0,0,6.1,6.41l84,.71A6.61,6.61,0,0,0,286.08,289.9Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.78,159.53a2.42,2.42,0,0,0-2.41-2.52l-81.11-.69a2.61,2.61,0,0,0-2.6,2.49l-4.94,128.87a2.43,2.43,0,0,0,2.41,2.53l81.11.68a2.6,2.6,0,0,0,2.6-2.48Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.41,246.25a37.82,37.82,0,0,0,8.13-21.49,34.72,34.72,0,0,0-6-21.48l0-.1a1.54,1.54,0,0,0-.25-.31,34.25,34.25,0,0,0-28.16-14.37,38.3,38.3,0,0,0-29.65,14.43,2.52,2.52,0,0,0-.21.25l-.05.09A37.62,37.62,0,0,0,206,224.76a34.62,34.62,0,0,0,6,21.5.36.36,0,0,1,0,.09l.09.1A34.26,34.26,0,0,0,240.49,261a38.25,38.25,0,0,0,29.61-14.39,3.33,3.33,0,0,0,.25-.28ZM240.7,256.71c-5.18,0-9.55-6.07-11.78-15a64,64,0,0,1,12.58-1.24A62.33,62.33,0,0,1,254,241.7C250.86,250.64,245.89,256.71,240.7,256.71Zm1-20.56a68.09,68.09,0,0,0-13.65,1.35,60.71,60.71,0,0,1-.73-10.58H257a63.63,63.63,0,0,1-1.77,10.58A66.11,66.11,0,0,0,241.72,236.15Zm-31.41-9.23H223a63.52,63.52,0,0,0,.78,11.62,43.78,43.78,0,0,0-9.11,3.7A30.42,30.42,0,0,1,210.31,226.92Zm6.11-19.64a39,39,0,0,0,8.75,3.7,66.73,66.73,0,0,0-1.93,11.63H210.52A33.18,33.18,0,0,1,216.42,207.28Zm27.43-14.46c5.19,0,9.56,6.06,11.79,15a63.4,63.4,0,0,1-12.59,1.24,61.43,61.43,0,0,1-12.46-1.24C233.7,198.88,238.66,192.82,243.85,192.82Zm-1,20.56A67.5,67.5,0,0,0,256.49,212a60.93,60.93,0,0,1,.72,10.59H227.56A62.91,62.91,0,0,1,229.32,212,65.57,65.57,0,0,0,242.84,213.38Zm31.41,9.23H261.53a65.46,65.46,0,0,0-.78-11.63,43.24,43.24,0,0,0,9.11-3.7A30.46,30.46,0,0,1,274.25,222.61Zm-12.93,4.31H274a33.36,33.36,0,0,1-5.9,15.32,39.71,39.71,0,0,0-8.75-3.7A67.57,67.57,0,0,0,261.32,226.92Zm6.08-23.11a39.85,39.85,0,0,1-7.51,3,34.44,34.44,0,0,0-5.25-12.05A30,30,0,0,1,267.4,203.81Zm-34.52-9.08a38.6,38.6,0,0,0-6.44,12.05,35.57,35.57,0,0,1-7.21-3A34.29,34.29,0,0,1,232.88,194.73Zm-15.72,51a39.74,39.74,0,0,1,7.5-3,34.63,34.63,0,0,0,5.26,12.05A29.94,29.94,0,0,1,217.16,245.72Zm34.52,9.08a38.93,38.93,0,0,0,6.44-12.05,36.39,36.39,0,0,1,7.21,3A34.2,34.2,0,0,1,251.68,254.8Z",
    style: {
      fill: "#65C18C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.79 156.47 205.38 290.28 224.58 290.44 238.99 156.63 219.79 156.47",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.54 156.69 231.13 290.5 239.01 290.56 253.42 156.75 245.54 156.69",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.12,154.74a1,1,0,0,0,1-1,.94.94,0,0,0-.94-1,1,1,0,0,0-1,1A.94.94,0,0,0,241.12,154.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.55,325.22,314.6,221.8a6.15,6.15,0,0,0-6.1-6.41l-48.57-.7a6.61,6.61,0,0,0-6.6,6.29l-5,103.43a6.14,6.14,0,0,0,6.1,6.4l48.57.71A6.61,6.61,0,0,0,309.55,325.22Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.55,325.22,314.6,221.8a6.15,6.15,0,0,0-6.1-6.41l-48.57-.7a6.61,6.61,0,0,0-6.6,6.29l-5,103.43a6.14,6.14,0,0,0,6.1,6.4l48.57.71A6.61,6.61,0,0,0,309.55,325.22Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.41,325.22l5-103.42a6.14,6.14,0,0,0-6.1-6.41l-48.57-.7a6.6,6.6,0,0,0-6.59,6.29l-5.05,103.43a6.14,6.14,0,0,0,6.1,6.4l48.57.71A6.62,6.62,0,0,0,311.41,325.22Z",
    style: {
      fill: "#65C18C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.11,223.2a2.44,2.44,0,0,0-2.41-2.53L263,220a2.61,2.61,0,0,0-2.6,2.49L255.48,323a2.43,2.43,0,0,0,2.41,2.53l45.68.68a2.6,2.6,0,0,0,2.6-2.48Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.56,287a23.21,23.21,0,0,0,5-13.19,21.34,21.34,0,0,0-3.69-13.19s0,0,0-.06a1.33,1.33,0,0,0-.14-.19,21.06,21.06,0,0,0-17.3-8.82,23.47,23.47,0,0,0-18.19,8.86l-.14.15,0,.06a23.13,23.13,0,0,0-5,13.19,21.22,21.22,0,0,0,3.69,13.2l0,.05s0,0,.05.06A21,21,0,0,0,282.2,296a23.48,23.48,0,0,0,18.17-8.83,1.37,1.37,0,0,0,.16-.18Zm-18.23,6.42c-3.19,0-5.87-3.72-7.23-9.21a39.32,39.32,0,0,1,7.72-.76,38.23,38.23,0,0,1,7.65.76C288.56,289.65,285.51,293.37,282.33,293.37Zm.62-12.62a41.85,41.85,0,0,0-8.38.83,37.48,37.48,0,0,1-.44-6.49h18.2a38.22,38.22,0,0,1-1.08,6.49A40.69,40.69,0,0,0,283,280.75Zm-19.28-5.66h7.81a39.64,39.64,0,0,0,.48,7.13,26.84,26.84,0,0,0-5.6,2.27A18.7,18.7,0,0,1,263.67,275.09ZM267.42,263a24.37,24.37,0,0,0,5.37,2.27,40.93,40.93,0,0,0-1.18,7.14H263.8A20.41,20.41,0,0,1,267.42,263Zm16.84-8.88c3.19,0,5.87,3.72,7.24,9.21a38.75,38.75,0,0,1-7.73.76,37.52,37.52,0,0,1-7.65-.76C278,257.87,281.08,254.15,284.26,254.15Zm-.62,12.62a41.85,41.85,0,0,0,8.38-.83,37.53,37.53,0,0,1,.44,6.5h-18.2a39.18,39.18,0,0,1,1.08-6.5A40.69,40.69,0,0,0,283.64,266.77Zm19.28,5.67h-7.81a39.76,39.76,0,0,0-.48-7.14,26.84,26.84,0,0,0,5.6-2.27A18.71,18.71,0,0,1,302.92,272.44ZM295,275.09h7.81a20.41,20.41,0,0,1-3.62,9.4,24.37,24.37,0,0,0-5.37-2.27A41,41,0,0,0,295,275.09Zm3.74-14.19a24.47,24.47,0,0,1-4.61,1.82,21.14,21.14,0,0,0-3.23-7.4A18.41,18.41,0,0,1,298.72,260.9Zm-21.19-5.58a23.82,23.82,0,0,0-4,7.4,21.91,21.91,0,0,1-4.43-1.82A21.06,21.06,0,0,1,277.53,255.32Zm-9.65,31.3a24.78,24.78,0,0,1,4.6-1.82,21.33,21.33,0,0,0,3.23,7.4A18.32,18.32,0,0,1,267.88,286.62Zm21.18,5.58a23.82,23.82,0,0,0,4-7.4,22.5,22.5,0,0,1,4.43,1.82A21.06,21.06,0,0,1,289.06,292.2Z",
    style: {
      fill: "#65C18C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.46 220.12 260.2 325.56 275.26 325.79 286.62 220.34 271.46 220.12",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.79 220.42 280.43 325.87 286.65 325.96 298.01 220.51 291.79 220.42",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37,218.56a1,1,0,0,0,1-1,1,1,0,0,0-.94-1,1,1,0,0,0-1,1A1,1,0,0,0,266.37,218.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/empty-list.924e998120b4048f967afa7613ae3af3.svg";
export { ForwardRef as ReactComponent };